var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topup-footer"},[_c('div',{staticClass:"topup-footer-bottom"},[_c('div',{staticClass:"topup-footer-copyrights",domProps:{"innerHTML":_vm._s(_vm.$t('component.footer.copyrights', {year: _vm.year}))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }